import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TotalStorageUsageResponse, PipesModule } from '@xmedical/core';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'xmed-upload-storage-usage',
  standalone: true,
  imports: [MatProgressBarModule, PipesModule],
  templateUrl: './upload-storage-usage.component.html',
  styleUrl: './upload-storage-usage.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadStorageUsageComponent {
  storageUsage = input<TotalStorageUsageResponse | null>(null);

  hasStorageUsage = computed(() => this.storageUsage() !== null);

  storageBarColor = computed<ThemePalette>(() => {
    const usage = this.storageUsage();
    return (usage?.storageUsedPercentage ?? 0) > 90.0 ? 'warn' : 'primary';
  });
}
